var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { color } from '@bfa/common-ui';
import styled, { css } from 'styled-components';
import { compose, space } from 'styled-system';
export var Divider = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-bottom: 1rem solid ", ";\n  ", "\n  ", "\n"], ["\n  border-bottom: 1rem solid ", ";\n  ", "\n  ", "\n"])), color('grayLightest'), function (_a) {
    var small = _a.small;
    return small && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-bottom: 0.1rem solid ", ";\n    "], ["\n      border-bottom: 0.1rem solid ", ";\n    "])), color('grayLightest'));
}, compose(space));
var templateObject_1, templateObject_2;
